export const en = {
    cancel: 'Cancel',
    close: 'Close',
    'feedback-icon-hint': 'Give feedback about the new interface',
    later: 'Later',
    'promo-content': 'Now you can give feedback about the beta version of the new Yandex.Direct interface.',
    'result-title': 'Thank you! Your feedback has been sent to the Yandex.Direct development team',
    send: 'Upload',
    'switch-to-old-interface-link': 'I want to revert to the old interface',
    'thanks-text':
        'We are actively developing the beta version. Every week, we introduce new options and eliminate issues reported by our users. Thank you for participating in beta testing! Your feedback helps us make Yandex.Direct better and more convenient for you.',
    title: 'Feedback',
    'we-will-connect-to-you-for-questions':
        'We might need additional information. In this case, we will contact you directly.',
    'write-any-feedback': 'Please share your thoughts about the new interface.',
    'write-feedback': 'Write a review'
};
